import { Button, rem, rgba } from "@mantine/core";
import { UseFormReturnType } from "@mantine/form";
import { ForgotPasswordForm as ForgotPasswordType } from "../../hooks/useForgotPasswordController";
import { FormTextInput } from "@/design-system/components/form/FormTextInput";

interface ForgotPasswordProps {
  form: UseFormReturnType<ForgotPasswordType>;
  loading: boolean;
  onSubmit: () => void;
}

export const ForgotPasswordForm = ({
  form,
  loading,
  onSubmit,
}: ForgotPasswordProps) => {
  const emailInput = form.getInputProps("email");

  return (
    <form
      onSubmit={form.onSubmit(onSubmit)}
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
      }}>
      <FormTextInput
        type="email"
        label="E-mail"
        c={rgba("var(--mantine-color-plain_text-0)", 0.5)}
        placeholder="Digite seu e-mail..."
        size="md"
        required
        withAsterisk={false}
        withErrorStyles={false}
        styles={{ input: { border: "none" } }}
        {...emailInput}
      />

      <Button
        fullWidth
        mt="md"
        size="sm"
        type="submit"
        radius={rem(8)}
        loading={loading}
        title="Preencha os campos corretamente para solicitar a redefinição de senha"
        disabled={!form.isValid() || loading}
        bg={"var(--mantine-color-contrast_text-0)"}
        ff={"heading"}
        fz={16}
        fw={700}>
        Redefinir senha
      </Button>
    </form>
  );
};
